<template>
  <of-dialog
    :title="formTitle"
    @onCancel="cancel"
    :class="{ hideButton: true }"
    :width="width"
  >
    <div slot="content">
      <el-form
        ref="form"
        label-width="120px"
        :model="dataForm"
        :disabled="true"
      >
        <el-form-item label="标题：">
          <p>{{dataForm.Title}}</p>
        </el-form-item>
        <el-form-item label="联系人：" >
          <p>{{dataForm.Contacts}}</p>
        </el-form-item>
        <el-form-item label="联系电话：" >
          <p>{{dataForm.Phone}}</p>
        </el-form-item>
        <el-form-item label="讲座类型：">
          <p>{{LectureType(dataForm.LectureType)}}</p>
        </el-form-item>
        <el-form-item label="讲座地点：" v-if="this.dataForm.LectureType === 0">
          <p>{{dataForm.Address}}</p>
        </el-form-item>
        <el-form-item label="讲座时间：" v-if="this.dataForm.LectureType === 0">
          <p>{{(dataForm.StartTime * 1000) | formatDate}}</p>
        </el-form-item>
        <el-form-item label="收费费用(元)：" v-if="this.dataForm.LectureType === 1">
          <p>{{dataForm.GroupCost}}</p>
        </el-form-item>
        <el-form-item label="学员名额(人)：" v-if="this.dataForm.LectureType === 0">
          <p>{{dataForm.StuPlaces}}</p>
        </el-form-item>
        <el-form-item label="报名须知：" >
          <p>{{dataForm.Condition}}</p>
        </el-form-item>
        <el-form-item label="封面图：" >
          <of-upload
            class="upload-demo"
            list-type="picture-card"
            @onPreview="onPreview"
            :fileList="pictureList"
            :class="{ hide: hideUploadEdit }"
          >
            <div slot="content">
              <i slot="default" class="el-icon-plus"></i>
            </div>
          </of-upload>
          <el-dialog :visible.sync="dialogVisible" :append-to-body="true">
            <img width="100%" :src="dialogImageUrl" alt />
          </el-dialog>
        </el-form-item>
        <el-form-item label="讲座介绍：" style="margin-top: 10px">
          <of-tinymce
            ref="editor"
            v-model="dataForm.Abstract"
            :height="500"
            :isEdit="isDisabled"
          ></of-tinymce>
        </el-form-item>
        <el-form-item label="上传附件：" >
          <of-upload
            class="upload-demo"
            list-type="fileList"
            @onPreview="onFilePreview"
            :fileList="fileList"
            :class="{ hideFile: hideUploadFileEdit }"
          >
            <div slot="content">
              <el-button size="mini">
                <i class="el-icon-upload el-icon--left"></i>上传文件
              </el-button>
            </div>
          </of-upload>
        </el-form-item>
      </el-form>
    </div>
  </of-dialog>
</template>
<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import OfUpload from "@/components/controls/of_upload/of_upload";
import OfTinymce from "@/components/controls/of_editor/of_tinymce_readonly";
import { saveAs } from "file-saver";
import api from "@/modules/zjrc/api";

export default {
  name: "edit",
  props: {
    id: {
      type: String,
      default: ""
    },
    formTitle: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      pictureList: [],
      fileList: [],
      dialogVisible: false,
      dialogImageUrl: "",
      hideUploadEdit: false,
      hideUploadFileEdit: false,
      width:"60%",
      dataForm:{}
    };
  },
  mounted() {
    this.loadData();
  },
  computed:{
    LectureType() {
      return data => {
        return data == 1 ? "收费" : "公益";
      };
    },
  },
  components: {
    OfDialog,
    OfUpload,
    OfTinymce
  },
  methods: {
    //初始化数据
    loadData(){
      let params = { id: this.id };
      api.QueryTrainById(params).then((res) => {
        if (res.data.Code === 0) {
          debugger
          this.dataForm = res.data.Data;
          this.getImg();
          this.getFile();
        }
      });
    },
    //取消
    cancel() {
      this.$emit("formCallBack", null);
    },
    //查看图片
    onPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //初始化封面图
    getImg() {
      if (
        this.dataForm.HeadImge === undefined ||
        this.dataForm.HeadImge === null ||
        this.dataForm.HeadImge == ""
      ) {
        return;
      }
      this.hideUploadEdit = true;
      this.$http
        .get("/Sys/File/Download?Id=" + this.dataForm.HeadImge)
        .then(res => {
          let pictureList = [res.config];
          this.pictureList = pictureList.map(item => {
            return {
              url: item.url
            };
          });
        });
    },
    //点击下载
    onFilePreview(file) {
      saveAs("/Sys/File/Download?Id=" + file.url, file.name);
    },
    //初始化附件
    getFile() {
      if (
        this.dataForm.File === undefined ||
        this.dataForm.File === null ||
        this.dataForm.File == ""
      ) {
        return;
      }
      this.fileList = JSON.parse(this.dataForm.File);
      this.hideUploadEdit = true;
    },
  }
};
</script>


<style scoped>
.el-textarea > textarea {
  height: 80px;
}

.upload-demo >>> .el-upload input[type="file"] {
  display: none !important;
}

.el-date-editor >>> .el-input__icon {
  display: none;
}
.el-date-editor >>> .el-input__inner {
  width: 90%;
}
.el-form >>> .el-form-item {
  margin-bottom: 0;
}
</style>

<style>
.hide {
  display: block !important;
}

.hideFile .el-upload--fileList {
  display: none;
}
.hideButton .el-button--primary {
  display: none;
}
</style>
